import React from "react";
import "./Choose.css";
import { assets } from "../../Assets/Assets";

function Choose() {
  return (
    <div className="main">
      <div className="choose">
        <div className="choose-image">
          <img src={assets.Choose} alt="" />
        </div>
        <img src={assets.Choose_content} alt="" className="img-cont-choos" />
        <div className="choose-content">
          <h4>Why Choose us</h4>
          <h3>Choose Us to Grow Your Business</h3>
          <p>
            Baraa has a three decades legacy and has proven to be resilient and
            adaptable when faced with difficulties.
          </p>
          <ul className="advantege">
            <li>
              <img src={assets.Activity} alt="" />
              <h6>Results-Driven Approach</h6>
            </li>
            <li>
              <img src={assets.Activity} alt="" />
              <h6>Expertise in Multiple Platforms</h6>
            </li>
            <li>
              <img src={assets.Activity} alt="" />
              <h6>Continuous Optimization</h6>
            </li>
          </ul>
        </div>
      </div>
      {/* brands slider */}
      {/* <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Our Brands</h2> */}
      <div className="clients-heading">Our Clients</div>

      <ul className="brands">
        <div className="brands-slider">
          <li>
            <img src={assets.Ar_group} alt="" />
          </li>
          <li>
            <img src={assets.Semaka} alt="" />
          </li>
          <li>
            <img src={assets.Dsi} alt="" />
          </li>
          <li>
            <img src={assets.Sc} alt="" />
          </li>
          <li>
            <img src={assets.millionero} alt="" />
          </li>
          <li>
            <img src={assets.Nexus} alt="" />
          </li>
          <li>
            <img src={assets.Metalok} alt="" />
          </li>
          <li>
            <img src={assets.arraham} alt="" />
          </li>
          {/* // replica */}
          <li>
            <img src={assets.Ar_group} alt="" />
          </li>
          <li>
            <img src={assets.Semaka} alt="" />
          </li>
          <li>
            <img src={assets.Dsi} alt="" />
          </li>
          <li>
            <img src={assets.Sc} alt="" />
          </li>
          <li>
            <img src={assets.millionero} alt="" />
          </li>
          <li>
            <img src={assets.Nexus} alt="" />
          </li>
          <li>
            <img src={assets.Metalok} alt="" />
          </li>
          <li>
            <img src={assets.arraham} alt="" />
          </li>
          {/* // replica */}
          
        </div>
      </ul>
    </div>
  );
}

export default Choose;
